<template>
    <section v-for="section in course.sections" :key="section">
        <h5
            class="text-slate-800 text-sm font-medium mb-4 flex flex-col lg:flex-row justify-between px-3"
        >
            {{ section.title }}
            <span class="text-slate-500 text-sm pt-3 lg:pt-0 whitespace-nowrap font-normal">
                {{ section.chapters.length }} lesson{{
                    section.chapters.length > 1 ? 's' : ''
                }}
            </span>
        </h5>
        <ul class="mb-8">
            <ListItem
                v-for="chapter in section.chapters"
                :chapter="chapter"
                :key="chapter"
            />
        </ul>
    </section>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';
import ListItem from '@/components/courses/chapter-list/list-item.vue';

const store = useCoursesStore();
const { course } = storeToRefs(store);
</script>
